import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  useAddDeviceMutation,
  useLoadAllDevicesQuery,
  useModifyDeviceMutation
} from "../../store";
import { SavedDevices } from "./SavedDevices";
import { Add } from "@mui/icons-material";
import { Fab } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { AddDeviceForm } from "./AddDeviceForm";
import { Device } from "../../store/apis/devicesApi";
import { SuccessErrorToast } from "../utils/SuccessErrorToast";
import { useLocation } from "react-router-dom";

export default function Devices() {
  const { data } = useLoadAllDevicesQuery(null);
  const [open, setOpen] = useState(false);

  const [addDevice, addDeviceResult] = useAddDeviceMutation();
  const [successAdd, setSuccessAdd] = useState(false);
  const [errorAdd, setErrorAdd] = useState(false);

  const [updateDevice, updateDeviceResult] = useModifyDeviceMutation();
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);

  const location = useLocation();

  const idRef = useRef("");

  useEffect(() => {
    console.log(location);
    if (location.state) {
      const path = location.state.from.pathname
        .split("/")
        .filter((p: string) => p.length);
      if (path[0] === "login") {
        if (path[1]) {
          idRef.current = path[1];
          setOpen(true);
        }
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (addDeviceResult.isSuccess) {
      setSuccessAdd(true);
    }
    if (addDeviceResult.isError) {
      setErrorAdd(true);
    }
  }, [addDeviceResult]);

  useEffect(() => {
    if (updateDeviceResult.isSuccess) {
      setSuccessUpdate(true);
    }
    if (updateDeviceResult.isError) {
      setErrorUpdate(true);
    }
  }, [updateDeviceResult]);

  const handleAddDevice = (device: Device) => {
    console.log(device);
    if (device.id) {
      updateDevice(device);
    } else {
      addDevice(device);
    }
  };

  return (
    <React.Fragment>
      <SuccessErrorToast
        successOpen={successAdd}
        errorOpen={errorAdd}
        successMessage="Laite lisätty onnistuneesti!"
        errormessage="Laitteen lisääminen epäonnistui!"
        setSuccessOpen={setSuccessAdd}
        setErrorOpen={setErrorAdd}
      />
      <SuccessErrorToast
        successOpen={successUpdate}
        errorOpen={errorUpdate}
        successMessage="Laite muokattu onnistuneesti!"
        errormessage="Laitteen muokkaus epäonnistui!"
        setSuccessOpen={setSuccessUpdate}
        setErrorOpen={setErrorUpdate}
      />
      <AddDeviceForm
        handleAddClose={() => setOpen(false)}
        handleAddDevice={handleAddDevice}
        open={open}
        id={idRef.current}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SavedDevices
            savedDevices={data || []}
            updateDevice={handleAddDevice}
          />
        </Grid>
      </Grid>
      <Fab
        className={"fab"}
        variant={"extended"}
        color={"primary"}
        onClick={() => {
          setOpen(true);
        }}
      >
        <Add />
        Lisää laite
      </Fab>
    </React.Fragment>
  );
}
